module.exports = __webpack_public_path__ + "static/media/landing_banner_english.3b21d46e.png";